import React from 'react';
import { FaEdit, FaTrash, FaEye, FaShoppingCart, FaMoon } from 'react-icons/fa';

const Account = () => {
  return (
    <div className="container mx-auto px-4 mt-8">
      {/* Header with Dark Mode Toggle */}
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-3xl font-bold text-primary">Account Dashboard</h1>
        <button className="btn btn-secondary flex items-center px-4 py-2">
          <FaMoon className="mr-2" /> Dark Mode
        </button>
      </div>

      {/* User Profile Section */}
      <section className="mb-8 bg-white shadow-lg rounded-lg p-8 flex items-center flex-wrap">
        <img 
          src="https://via.placeholder.com/100" 
          alt="User Profile" 
          className="rounded-full border-4 border-primary mr-6" 
        />
        <div className="flex-grow">
          <h2 className="text-4xl font-bold text-primary mb-2">John Doe</h2>
          <p className="text-gray-700 text-lg">john.doe@example.com</p>
          <p className="text-gray-700 text-lg">+1 234 567 890</p>
          <button className="btn btn-primary flex items-center mt-4 px-4 py-2">
            <FaEdit className="mr-2" /> Edit Profile
          </button>
        </div>
      </section>

      {/* Reward Points Section */}
      <section className="mb-8 bg-indigo-100 shadow-lg rounded-lg p-8 flex items-center justify-between">
        <div>
          <h4 className="text-xl font-bold text-primary">Reward Points</h4>
          <p className="text-gray-700">You have <span className="text-indigo-600 font-bold">150</span> reward points!</p>
        </div>
        <button className="btn btn-indigo-600 text-white flex items-center px-6 py-2">
          <FaShoppingCart className="mr-2" /> Redeem Points
        </button>
      </section>

      {/* Order History Section */}
      <section className="mb-8 bg-white shadow-lg rounded-lg p-8">
        <h4 className="text-2xl font-bold mb-6">Order History</h4>
        <div className="overflow-x-auto">
          <table className="min-w-full border">
            <thead className="bg-primary text-white">
              <tr>
                <th className="border px-6 py-3 text-left">Order ID</th>
                <th className="border px-6 py-3 text-left">Date</th>
                <th className="border px-6 py-3 text-left">Status</th>
                <th className="border px-6 py-3 text-left">Total</th>
                <th className="border px-6 py-3 text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              {[1, 2, 3].map((item) => (
                <tr key={item} className="hover:bg-gray-100 transition">
                  <td className="border px-6 py-4">#12345{item}</td>
                  <td className="border px-6 py-4">2023-09-01</td>
                  <td className="border px-6 py-4">
                    <span className="bg-green-100 text-green-600 px-2 py-1 rounded">Shipped</span>
                  </td>
                  <td className="border px-6 py-4">$49.99</td>
                  <td className="border px-6 py-4 text-center">
                    <button className="btn btn-outline-primary flex items-center justify-center px-4 py-2">
                      <FaEye className="mr-2" /> View
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      {/* Activity Log Section */}
      <section className="mb-8 bg-white shadow-lg rounded-lg p-8">
        <h4 className="text-2xl font-bold mb-6">Recent Activity</h4>
        <ul className="space-y-4">
          <li className="flex items-center">
            <span className="text-green-600 bg-green-100 p-2 rounded-full mr-4">
              <FaShoppingCart />
            </span>
            <p className="text-gray-700">You placed an order on <strong>2023-09-15</strong>.</p>
          </li>
          <li className="flex items-center">
            <span className="text-indigo-600 bg-indigo-100 p-2 rounded-full mr-4">
              <FaEdit />
            </span>
            <p className="text-gray-700">You updated your profile on <strong>2023-09-10</strong>.</p>
          </li>
        </ul>
      </section>

      {/* Wishlist Section */}
      <section className="mb-8 bg-white shadow-lg rounded-lg p-8">
        <h4 className="text-2xl font-bold mb-6">Wishlist</h4>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {[1, 2, 3, 4].map((item) => (
            <div key={item} className="border rounded-lg p-6 hover:shadow-lg transition duration-300 bg-gray-50">
              <h5 className="font-semibold text-xl mb-2">Product Name {item}</h5>
              <p className="text-gray-600">Brief description of the product goes here.</p>
              <div className="flex justify-between items-center mt-4">
                <span className="text-primary font-bold">$19.99</span>
                <button className="btn btn-outline-danger flex items-center px-4 py-2">
                  <FaTrash className="mr-2" /> Remove
                </button>
              </div>
            </div>
          ))}
        </div>
        <button className="btn btn-primary mt-6 px-6 py-2">View All</button>
      </section>

      {/* Address Section */}
      <section className="mb-8 bg-white shadow-lg rounded-lg p-8">
        <h4 className="text-2xl font-bold mb-6">Addresses</h4>
        <div className="mb-6">
          <h5 className="font-semibold text-lg mb-2">Primary Address</h5>
          <p className="text-gray-700">123 Main St, City, Country</p>
          <button className="btn btn-outline-primary flex items-center mt-4 px-4 py-2">
            <FaEdit className="mr-2" /> Edit Address
          </button>
        </div>
        <div>
          <h5 className="font-semibold text-lg mb-2">Secondary Address</h5>
          <p className="text-gray-700">456 Another St, City, Country</p>
          <button className="btn btn-outline-primary flex items-center mt-4 px-4 py-2">
            <FaEdit className="mr-2" /> Edit Address
          </button>
        </div>
      </section>

      {/* Additional Features Section */}
      <section className="mb-8 bg-white shadow-lg rounded-lg p-8">
        <h4 className="text-2xl font-bold mb-6">Additional Features</h4>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          <div className="border rounded-lg p-6 bg-gray-100 hover:shadow-lg transition duration-300">
            <h5 className="font-semibold text-lg mb-2">Notification Preferences</h5>
            <p className="text-gray-600 mb-4">Manage your email and SMS notifications.</p>
            <button className="btn btn-outline-primary flex items-center px-4 py-2">
              <FaEdit className="mr-2" /> Edit Preferences
            </button>
          </div>
          <div className="border rounded-lg p-6 bg-gray-100 hover:shadow-lg transition duration-300">
            <h5 className="font-semibold text-lg mb-2">Payment Methods</h5>
            <p className="text-gray-600 mb-4">Add or update your payment methods.</p>
            <button className="btn btn-outline-primary flex items-center px-4 py-2">
              <FaEdit className="mr-2" /> Edit Payments
            </button>
          </div>
        </div>
      </section>

      {/* Progress Indicator */}
      <section className="mb-8 bg-white shadow-lg rounded-lg p-8">
        <h4 className="text-2xl font-bold mb-6">Order Progress</h4>
        <div className="bg-gray-100 rounded-lg p-4">
          <p className="mb-2 text-lg font-semibold">Order #123451</p>
          <div className="w-full bg-gray-300 rounded-full h-4">
            <div className="bg-primary h-4 rounded-full" style={{ width: '75%' }}></div>
          </div>
          <p className="mt-2 text-sm text-gray-600">75% completed (Shipped)</p>
        </div>
      </section>
    </div>
  );
};

export default Account;
